/* eslint-disable no-plusplus */
import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { formatNumber } from 'utils/formats';
import { TradingOfferSellerInfo } from '../../../types/TradingOffer';

type TradingOfferSellerInfoCardProps = {
  sellerInfo: TradingOfferSellerInfo;
};

const TradingOfferSellerInfoCard: FC<TradingOfferSellerInfoCardProps> = ({
  sellerInfo,
}) => {
  const { t } = useTranslate();

  const initials = sellerInfo.name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <em
          key={i}
          className={`icon ni ${
            i <= rating ? 'ni-star-fill text-warning' : 'ni-star text-soft'
          }`}
        />
      );
    }
    return stars;
  };

  return (
    <div className="card card-bordered">
      <div className="card-inner">
        <h6 className="card-title text-base">{t('SellerInformation')}</h6>

        <div className="d-flex align-items-center mb-3">
          <div className="user-avatar lg bg-primary-dim mr-3">
            {sellerInfo.image ? (
              <img src={sellerInfo.image} alt={sellerInfo.name} />
            ) : (
              <span>{initials}</span>
            )}
          </div>
          <div>
            <h6 className="mb-0">{sellerInfo.name}</h6>
            <span className="sub-text">
              {t('MemberSince')} {sellerInfo.memberSince}
            </span>
          </div>
        </div>

        <ul className="nk-list-plain">
          <li className="d-flex justify-content-between py-2">
            <span className="sub-text">{t('TotalShares')}</span>
            <span className="lead-text">
              {formatNumber(sellerInfo.totalShares)}
            </span>
          </li>
          <li className="d-flex justify-content-between py-2">
            <span className="sub-text">{t('CapitalPercentage')}</span>
            <span className="lead-text">
              {sellerInfo.capitalPercentage.toFixed(2)}%
            </span>
          </li>
          <li className="d-flex justify-content-between py-2">
            <span className="sub-text">{t('PreviousOperations')}</span>
            <span className="lead-text">{sellerInfo.previousOperations}</span>
          </li>
          <li className="d-flex justify-content-between py-2">
            <span className="sub-text">{t('Rating')}</span>
            <span className="lead-text d-flex gap-1">
              {renderStars(sellerInfo.rating)}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TradingOfferSellerInfoCard;
